import React, { useEffect, useState, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import axios from "axios";
import {
  TABLE_ENQUIRY_LIST,
  ENQUIRIES_LIST_ENDPOINT,
  FILTER_TYPE_BUTTON,
  FILTER_TYPE_MULTI_SELECT_DROPDOWN,
} from "@utils/constants";
import { Title } from "./EnquiryList.styled";
import { loadAllEnquiries } from "./EnquiryList.actionCreators";
import { setAllEnquiriesLoadingState } from "./EnquiryList.slice";
import EncloseTable from "@shared/baseUI/EnhancedTable/EncloseTable";
import { columnHeader, isEmpty } from "@utils/utils";
import UserInfo from "@utils/UserInfo";
import EnquiryId from "./components/EnquiryId";
import SiteInfo from "./components/SiteInfo";
import SiteTender from "./components/SiteTender";
import Product from "./components/Product";
import Operation from "./components/Operation";
import Quantity from "./components/Quantity";
import CreationDate from "./components/CreationDate";
import Priority from "./components/Priority";
import Step from "./components/Step";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import { enquiryTypeOptions } from "@utils/filterOptions";
import TransportQuotations from "../../TransportQuotations/TransportQuotationsList/TransportQuotationsList";

const PrepareDataTable = (props) => {
  const { t, isRefreshList, updateRefeshStatus, columnList, type, entityId } =
    props;
  const prevCountRef = useRef();
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(1);
  const [isRefreshDataAgain, setRefreshState] = useState(false);
  const [skipPageReset, setSkipPageReset] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [currentPageToFirst, setCurrentPageToFirst] = useState(false);
  const [additionalFilters, setAdditionalFilters] = useState([]);
  const [isAdminSuggestionsLoading, setAdminSuggestionsLoading] =
    useState(false);
  const [adminList, setAdminList] = useState([]);

  const mainCountryInfo = UserInfo.countryInfo();

  const countryId = UserInfo.countryId();
  const countryList = UserInfo.countryListForFilter(t);

  const [selectedFilter, setSelectedFilter] = useState([
    {
      column: "country",
      value: {
        value: mainCountryInfo?.country?.id,
        label: t(mainCountryInfo?.country?.name),
      },
    },
  ]);

  const dataURL = ENQUIRIES_LIST_ENDPOINT;
  const dispatch = useDispatch();

  let columns = [
    {
      Header: t("ID"),
      title: "ID",
      accessor: "idInfo",
      // eslint-disable-next-line react/prop-types
      Cell: ({ cell: { value } }) => (
        <EnquiryId
          data={"#" + value.id}
          id={value.id}
          siteId={value.siteId}
          isActive={value.isActive}
          updateRefeshStatus={updateRefeshStatus}
        />
      ),
      disableFilters: true,
    },
    {
      Header: t("SITE_TYPE"),
      title: "SITE_TYPE",
      accessor: "siteTender",
      Cell: ({ cell: { value } }) => <SiteTender data={value} />,
      disableFilters: true,
    },
    {
      Header: t("SITE_COMPANY"),
      title: "SITE_COMPANY",
      accessor: "siteCompany",
      Cell: ({ cell: { value } }) => <SiteInfo data={value} />,
      disableFilters: true,
    },
    {
      Header: t("PRODUCT"),
      title: "PRODUCT",
      accessor: "product",
      Cell: ({ cell: { value } }) => <Product data={value} />,
      disableFilters: true,
    },
    {
      Header: t("OPERATION"),
      title: "OPERATION",
      accessor: "operation",
      Cell: ({ cell: { value } }) => <Operation data={value} />,
      disableFilters: true,
    },
    {
      Header: t("QUANTITY"),
      title: "QUANTITY",
      accessor: "quanityInfo",
      Cell: ({ cell: { value } }) => <Quantity data={value} />,
      disableFilters: true,
    },
    {
      Header: t("ENQUIRY_CREATION_DATE"),
      title: "ENQUIRY_CREATION_DATE",
      accessor: "dateInfo",
      Cell: ({ cell: { value } }) => (
        <CreationDate data={value} type="creation" />
      ),
      disableFilters: true,
    },
    {
      Header: t("ENQUIRY_PRIORITY"),
      title: "ENQUIRY_PRIORITY",
      accessor: "priorityInfo",
      Cell: ({ cell: { value } }) => <Priority data={value} />,
      disableFilters: true,
    },
    {
      Header: t("ENQUIRY_STEP"),
      title: "ENQUIRY_STEP",
      accessor: "step",
      Cell: ({ cell: { value } }) => <Step data={value} />,
      disableFilters: true,
    },
    {
      Header: t("ENQUIRY_DUE_DATE"),
      title: "ENQUIRY_DUE_DATE",
      accessor: "turnAroundDateInfo",
      Cell: ({ cell: { value } }) => (
        <CreationDate data={value} type="dueDate" />
      ),
      disableFilters: true,
    },
  ];

  columns = columnHeader(columns, columnList);

  const enquiryListByIds = useSelector((state) => state.enquiryList.byId);
  const enquiryListAllIds = useSelector((state) => state.enquiryList.allIds);
  const filteredRecords = useSelector(
    (state) => state.enquiryList.filteredRecords
  );

  const isRequestListLoading = useSelector(
    (state) => state.enquiryList.isLoading
  );

  useEffect(() => {
    setLoading(isRequestListLoading);
  }, [isRequestListLoading]);
  /**
   * Method to fetch set of records based on the filters applied.
   * @param {pageSize} pageSize
   * @param {pageStart} pageStart
   * @param {globalFilter} globalFilter
   * @param {sort} sort
   * @param {appliedFilters} appliedFilters
   */
  const fetchRecords = ({
    pageSize,
    pageStart,
    globalFilter,
    sort,
    appliedFilters,
    currentPage,
  }) => {
    // save request data,
    setRequestData({
      pageSize,
      pageStart,
      globalFilter,
      sort,
      appliedFilters,
      currentPage,
    });

    let salesman = [];
    let statusFilters = [];
    let selectedCountries = [];

    if (additionalFilters.length > 0) {
      const salesmanFilter = additionalFilters.filter(
        (filterItem) => filterItem.column === "salesman"
      );
      salesman = salesmanFilter?.map((item) => item.value);

      const statusFilter = additionalFilters.filter(
        (filterItem) => filterItem.column === "quoteStatus"
      );
      statusFilters = statusFilter?.map((item) => item.value);

      const countryTypeFilter = additionalFilters.filter(
        (filterItem) => filterItem.column === "country"
      );
      selectedCountries = countryTypeFilter?.map((item) => item.value);
    }
    if (selectedCountries.length === 0) {
      selectedCountries = countryId;
    }
    if (type === "to-process") {
      statusFilters = [1];
    }
    // Set the loading state
    setLoading(true);
    dispatch(setAllEnquiriesLoadingState());
    dispatch(
      loadAllEnquiries({
        dataURL,
        siteId: entityId ?? "",
        pageSize,
        currentPage,
        sort,
        search: globalFilter,
        status,
        statusFilters,
        salesman,
        selectedCountries,
      })
    );
  };

  useEffect(() => {
    if (enquiryListAllIds.length > 0) {
      const responseData = enquiryListAllIds.map((id) => {
        const tempData = { ...enquiryListByIds[id] };
        tempData.idInfo = {
          id: tempData.id,
          siteId: tempData?.site?.id,
          isActive: tempData.isActive,
        };
        tempData.siteTender = {
          isTender: tempData?.site?.isTender,
          isActive: tempData.isActive,
        };
        tempData.siteCompany = {
          id: tempData.id,
          companyName: tempData?.site?.companyName,
          siteId: tempData?.site?.id,
          siteName: tempData?.site?.name,
          isActive: tempData.isActive,
        };
        tempData.product = {
          id: tempData.id,
          name: tempData?.product?.name,
          categoryName: tempData?.product?.category?.name,
          subCategoryName: tempData?.product?.subCategory?.name,
          isActive: tempData.isActive,
        };
        tempData.operation = {
          id: tempData.id,
          isActive: tempData.isActive,
          serviceType: tempData.service,
        };
        tempData.quanityInfo = {
          id: tempData.id,
          quantity: tempData.quantity,
          unit: tempData.unit,
          isActive: tempData.isActive,
        };
        tempData.dateInfo = {
          id: tempData.id,
          isActive: tempData.isActive,
          date: tempData.createdAt
            ? moment(tempData.createdAt).format("YYYY-MM-DD")
            : null,
        };
        tempData.turnAroundDateInfo = {
          id: tempData.id,
          isActive: tempData.isActive,
          date: tempData.dueDate
            ? moment(tempData.dueDate).format("YYYY-MM-DD")
            : null,
          dueDateFormat: tempData.dueDate
            ? moment(tempData.dueDate).format("Y-M-D")
            : null,
        };
        tempData.priorityInfo = {
          id: tempData.id,
          isActive: tempData.isActive,
          priority: tempData.priority,
          dueDate: tempData.dueDate,
          step: tempData.step,
        };
        tempData.step = {
          id: tempData.id,
          step: tempData.step,
          isActive: tempData.isActive,
        };
        return tempData;
      });
      setData([...responseData]);
      setPageCount(filteredRecords);
      setLoading(false);
    } else {
      setData([]);
      setPageCount(0);
      setLoading(false);
    }
  }, [t, enquiryListAllIds, enquiryListByIds, filteredRecords]);

  useEffect(() => {
    if (isRefreshDataAgain) {
      setRefreshState(false);
    }
    if (isRefreshList) {
      setRefreshState(true);
    }
  }, [isRefreshDataAgain, isRefreshList]);

  const changeStatus = () => {
    const statusNew = status === 1 ? 2 : 1;
    setStatus(statusNew);
  };

  useEffect(() => {
    // everyTime we apply an custom filter we reset the page to 1
    setCurrentPageToFirst(true);
    if (
      !isEmpty(requestData) &&
      requestData.currentPage === 1 &&
      (type === "all" || type === "to-process")
    ) {
      fetchRecords({
        pageSize: requestData.pageSize,
        pageStart: requestData.pageStart,
        globalFilter: requestData.globalFilter,
        sort: requestData.sort,
        currentPage: requestData.currentPage,
        appliedFilters: additionalFilters,
      });
    }
  }, [status, additionalFilters]);

  const getAdmins = (countryIdList) => {
    setAdminSuggestionsLoading(true);
    axios
      .get(
        `/general/search?&limit=-1&countries=[${countryIdList}]&objectTypes=["admin"]`
      )
      .then((response) => {
        const entityGroupList = [];
        if (response?.data?.admins) {
          response.data.admins.map((key) => {
            entityGroupList.push({
              label: key.id + " - " + key.firstName + " " + key.lastName,
              value: key.id,
            });
          });
        }
        setAdminList(entityGroupList);
        setAdminSuggestionsLoading(false);
      })
      .catch((error) => {
        if (window.debugMode) {
          Console.error(
            "Error: an error occurred while fetching admins",
            error
          );
        }
        setAdminList([]);
        setAdminSuggestionsLoading(false);
      });
  };

  useEffect(() => {
    getAdmins(countryId);
  }, []);

  useEffect(() => {
    const previousCountry = prevCountRef.current;
    const countryTypeFilter = additionalFilters.filter(
      (filterItem) => filterItem.column === "country"
    );
    let selectedCountries = countryTypeFilter?.map((item) => item.value);
    if (selectedCountries.length === 0) {
      selectedCountries = [countryId];
    }
    prevCountRef.current = selectedCountries;
    const isSame =
      selectedCountries?.length === previousCountry?.length &&
      selectedCountries.every(
        (value, index) => value === previousCountry[index]
      );
    if (previousCountry?.length > 0 && !isSame) getAdmins(selectedCountries);
  }, [additionalFilters]);

  return (
    <>
      <Title>{t("SITES")}</Title>
      {type === "all" && (
        <EncloseTable
          type={TABLE_ENQUIRY_LIST}
          columns={columns}
          data={data}
          setData={setData}
          initialPageSize={30}
          isRefreshDataAgain={isRefreshDataAgain}
          setSkipPageReset={setSkipPageReset}
          skipPageReset={skipPageReset}
          pageCount={pageCount}
          currentPageToFirst={currentPageToFirst}
          setCurrentPageToFirst={setCurrentPageToFirst}
          setPageCount={setPageCount}
          fetchRecords={fetchRecords}
          loading={loading}
          setAdditionalFilters={setAdditionalFilters}
          additionalFilters={additionalFilters}
          defaultSortOptions={[{ id: "id", desc: true, dir: "desc" }]}
          selectedFilter={selectedFilter}
          extraFilters={[
            ...(countryList?.length > 1
              ? [
                  {
                    type: FILTER_TYPE_MULTI_SELECT_DROPDOWN,
                    label: t("COUNTRY"),
                    name: "country",
                    labelClass: "enquiry-listing__admins-list-label",
                    containerClass:
                      "enquiry-listing__status-list-dropdown-container",
                    options: countryList,
                    placeholder: t("SEARCH"),
                    defaultOption: "Nothing Selected",
                  },
                ]
              : []),
            {
              type: FILTER_TYPE_BUTTON,
              label: "ENQUIRIES_LIST_TOGGLE_ACTIVE_ONLY",
              name: "users",
              labelClass: "enquiry-listing__statis-list-label",
              containerClass: "enquiry-listing__admins-list-dropdown-container",
              imageEnableIcon: enableIcon,
              imageDisableIcon: disableIcon,
              status,
              changeStatus: { changeStatus },
            },
            {
              type: FILTER_TYPE_MULTI_SELECT_DROPDOWN,
              label: t("ENQUIRIES_FILTER_STEP"),
              name: "quoteStatus",
              labelClass: "enquiry-listing__admins-list-label",
              containerClass: "enquiry-listing__status-list-dropdown-container",
              defaultOption: "Nothing Selected",
              options: enquiryTypeOptions(t),
              placeholder: t("SEARCH"),
            },
            {
              type: FILTER_TYPE_MULTI_SELECT_DROPDOWN,
              label: t("ENQUIRIES_FILTER_PERSON_IN_CHARGE"),
              placeholder: t("SEARCH"),
              name: "salesman",
              labelClass: "enquiry-listing__admins-list-label",
              containerClass: "enquiry-listing__status-list-dropdown-container",
              defaultOption: "Nothing Selected",
              options: adminList,
            },
          ]}
        />
      )}
      {type === "to-process" && (
        <EncloseTable
          type={TABLE_ENQUIRY_LIST}
          columns={columns}
          data={data}
          setData={setData}
          initialPageSize={30}
          isRefreshDataAgain={isRefreshDataAgain}
          setSkipPageReset={setSkipPageReset}
          skipPageReset={skipPageReset}
          pageCount={pageCount}
          currentPageToFirst={currentPageToFirst}
          setCurrentPageToFirst={setCurrentPageToFirst}
          setPageCount={setPageCount}
          fetchRecords={fetchRecords}
          loading={loading}
          setAdditionalFilters={setAdditionalFilters}
          additionalFilters={additionalFilters}
          defaultSortOptions={[{ id: "id", desc: true, dir: "desc" }]}
          selectedFilter={selectedFilter}
          extraFilters={[
            ...(countryList?.length > 1
              ? [
                  {
                    type: FILTER_TYPE_MULTI_SELECT_DROPDOWN,
                    label: t("COUNTRY"),
                    name: "country",
                    labelClass: "enquiry-listing__admins-list-label",
                    containerClass:
                      "enquiry-listing__status-list-dropdown-container",
                    options: countryList,
                    placeholder: t("SEARCH"),
                    defaultOption: "Nothing Selected",
                  },
                ]
              : []),
            {
              type: FILTER_TYPE_MULTI_SELECT_DROPDOWN,
              label: t("ENQUIRIES_FILTER_PERSON_IN_CHARGE"),
              placeholder: t("SEARCH"),
              name: "salesman",
              labelClass: "enquiry-listing__admins-list-label",
              containerClass: "enquiry-listing__status-list-dropdown-container",
              defaultOption: "Nothing Selected",
              options: adminList,
            },
          ]}
        />
      )}
      {type === "transport-quotation" && <TransportQuotations />}
    </>
  );
};

PrepareDataTable.propTypes = {
  t: PropTypes.func.isRequired,
  isRefreshList: PropTypes.bool.isRequired,
  columnList: PropTypes.array.isRequired,
  updateRefeshStatus: PropTypes.func,
};
PrepareDataTable.defaultProps = {
  updateRefeshStatus: {},
};

export default withTranslation()(PrepareDataTable);
